
/**
 * A reusable List Skeleton Loader component for a loading state.
 *
 * It mimics a list with an avatar and two lines of text per item.
 * @param {number} count The number of list items to display (default is 4).
 */
const ListSkeletonLoader = ({ count = 4 }) => {
    // Create an array to iterate over for the specified number of items
    const skeletonItems = Array.from({ length: count });

    // Array of placeholder text widths for a more natural look
    const line1Widths = ["w-3/4", "w-5/6", "w-2/3", "w-4/5"];
    const line2Widths = ["w-full", "w-11/12", "w-10/12", "w-7/8"];

    return (
        <div className="w-full mx-auto rounded-lg shadow-md">
            {/* Apply the pulse animation to the main container */}
            <div role="status" className="animate-pulse space-y-4">
                {skeletonItems.map((_, index) => (
                    <div key={index} className="flex-1 flex-col items-center space-y-2 border border-gray-800 rounded-xl rounded-tr-md  p-2.5">
                        <div className="flex flex-1 items-center space-x-4">
                            {/* Avatar/Icon Placeholder (Circular) */}
                            <div className="w-20 h-20 rounded-2xl rounded-tr-md bg-gray-800"></div>

                            {/* Text Placeholders */}
                            <div className="flex-1 space-y-3">
                                {/* Line 1 - Vary the width using a modulo index */}
                                <div
                                    className={`h-4 bg-gray-800 rounded ${line1Widths[index % line1Widths.length]}`}
                                ></div>

                                {/* Line 2 - Always a bit wider than Line 1 */}
                                <div
                                    className={`h-4 bg-gray-800 rounded ${line2Widths[index % line2Widths.length]}`}
                                ></div>
                                <div
                                    className={`h-4 bg-gray-800 rounded ${line2Widths[index % line2Widths.length]}`}
                                ></div>
                            </div>
                        </div>
                        {/* <div
                            className={`h-4 bg-gray-300 rounded dark:bg-gray-700 w-full`}
                        ></div> */}
                    </div>
                ))}
            </div>
            <span className="sr-only">Loading content...</span>
        </div>
    );
};

export { ListSkeletonLoader }